// import { createRouter, createWebHistory } from 'vue-router';
import { createRouter as createIonicRouter } from '@ionic/vue-router';
import { createWebHistory } from 'vue-router';
// import HelloWorld from '../components/HelloWorld.vue'
// import TabsPage from '../views/TabsPage.vue';
// import { customPageTransition } from '../animations';
import LayoutTabs from '@/components/welcome/LayoutTabs.vue';

const routes = [
  {
    path: '/welcome',
    component: () => import('../views/WelcomePage.vue'),
  },
  // {
  //   path: '/',
  //   component: () => import('../views/TunerPage.vue'),
  // },
  // {
  //   path: '/metronome',
  //   component: () => import('../views/MetronomePage.vue'),
  // },
  {
    path: '/',
    redirect: '/tabs/tuner',
  },
  {
    path: '/tabs',
    component: LayoutTabs,
    children: [
      {
        path: 'tuner',
        component: () => import('../views/TunerPage.vue'),
      },
      // {
      //   path: 'riffs',
      //   component: () => import('../views/RiffsPage.vue'),
      // },
      {
        path: 'chords',
        component: () => import('../views/ProgressionsPage.vue'),
      },
      {
        path: 'metronome',
        component: () => import('../views/MetronomePage.vue'),
      },
      {
        path: 'settings',
        component: () => import('../views/InfoPage.vue'),
      },
      // {
      //   path: 'riffs/colab/:id',
      //   name: 'AudioDetailPage',
      //   component: () => import('../views/AudioDetailPage.vue')
      // },
      // {
      //   path: 'riffs/record',
      //   name: 'AudioRecordPage',
      //   component: () => import('../views/AudioRecordPage.vue')
      // }
      // {
      //   path: 'search',
      //   component: () => import('./views/SearchPage.vue'),
      // },
    ],
  },
  {
    path: '/tuning/:instrumentId/:typeId/:tuningId',
    name: 'TuningDetail',
    component: () => import('@/views/TuningDetail.vue')
  },
  
  // {
  //   path: '/welcome/1',
  //   component: () => import('../views/Hi1Page.vue')
  // },
  // {
  //   path: '/welcome/2',
  //   component: () => import('../views/Hi2Page.vue')
  // },
  // {
  //   path: '/welcome/3',
  //   component: () => import('../views/Hi3Page.vue')
  // },
  // {
  //   path: '/tuner',
  //   component: () => import('../views/TunerPage.vue'),
  // },
  // {
  //   path: '/tunings',
  //   component: () => import('../views/TuningsPage.vue'),
  // },
  // {
  //   path: '/settings',
  //   component: () => import('../views/SettingsPage.vue'),
  // },
  // {
  //   path: '/account',
  //   component: () => import('../views/AccountPage.vue'),
  // },
];



const router = createIonicRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  // const ionRouter = document.querySelector('ion-router');
  // if (ionRouter) {
  //   ionRouter.animation = customPageTransition;
  // }
  // Check if the user has already seen the welcome page
  const hasVisitedWelcome = localStorage.getItem('hasVisitedWelcome');

  // If user has not visited welcome page and is not already on it, redirect to welcome page
  if (!hasVisitedWelcome && to.path !== '/welcome') {
    next('/welcome');
  } else {
    next();
  }
});

export default router;


